const clone = (array: any):any => {
    return JSON.parse(JSON.stringify(array));
}

export { clone };